import { useState } from 'react';
import IngredientInspect from './IngredientInspect';
import VendorInspect from './VendorInspect';

export default function InspectName({type,item,ings,batches,mi,orgId,t,onEdit,onSwap,onViewExpenses,setInvoiceModalId,children,style,save,setIngs,settings,si,sb,mn}){
const[open,setOpen]=useState(false);

return(<>
<span onClick={e=>{e.stopPropagation();setOpen(true);}} style={{cursor:'pointer',borderBottom:`1px dashed ${t?.bd||'#ddd'}`,transition:'opacity 0.15s',...style}} onMouseOver={e=>e.currentTarget.style.opacity='0.7'} onMouseOut={e=>e.currentTarget.style.opacity='1'}>
{children}
</span>
{open&&type==='ingredient'&&<IngredientInspect ig={item} ings={ings} batches={batches} mi={mi} orgId={orgId} t={t} onClose={()=>setOpen(false)} onEdit={onEdit} onSwap={onSwap} save={save} setIngs={setIngs} settings={settings} si={si} sb={sb} mn={mn}/>}
{open&&type==='vendor'&&<VendorInspect vendor={item} orgId={orgId} t={t} ings={ings} batches={batches} mi={mi} onClose={()=>setOpen(false)} onEdit={onEdit} onViewExpenses={onViewExpenses} setInvoiceModalId={setInvoiceModalId}/>}
</>);
}
